module.exports = __webpack_public_path__ + "img/body-1.f0a30758.png";